import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./Sidebar.css";
import { FaQuestionCircle } from "react-icons/fa";
import { UploadIcon, BarChart3, Zap, Lock } from "lucide-react";
import { DashboardIcon, DataSourceIcon } from "../../assets/icon/svgIcons";
import MyLogo from "../../assets/chatbot.png";

const Sidebar = ({ isOpen }) => {
  const location = useLocation(); // Get current path to highlight active tab

  const { Dashboard, DataSource } = JSON.parse(
    sessionStorage.getItem("rolesAndPermission") || "{}"
  );

  return (
    <>
      {!isOpen && (
        <div className="sidebar closed">
          <ul className={`sidebar-menu ${isOpen ? "" : "margin-closed"}`}>
            {Dashboard?.canView && (
              <li
                className={location.pathname === "/dashboard" ? "active" : ""}
              >
                <Link
                  className={`flex ${
                    !isOpen ? "flex-col" : "flex-row"
                  } sidebar-dashboard-joyride-class`}
                  to="/dashboard"
                  title="Dashboard"
                >
                  <DashboardIcon />
                  <div className="sidebar-label">Dashboard</div>
                </Link>
              </li>
            )}
            {DataSource?.canView && (
              <li
                className={
                  location.pathname.includes("/data-sources") ? "active" : ""
                }
              >
                <Link
                  className={`flex ${
                    !isOpen ? "flex-col" : "flex-row"
                  } sidebar-datasource-joyride-class`}
                  to="/data-sources"
                  title="Data Sources"
                >
                  <DataSourceIcon />
                  <div className="sidebar-label">Data Sources</div>
                </Link>
              </li>
            )}
            <li
              className={location.pathname === "/data-quality" ? "active" : ""}
            >
              <Link
                className={` flex ${
                  !isOpen ? "flex-col" : "flex-row"
                } sidebar-upload-joyride-class`}
                to="/data-quality"
                title="Data Quality"
              >
                <BarChart3 className="menu-icon" />
                <div className="sidebar-label">Data Quality</div>
              </Link>
            </li>
            <li
              className={location.pathname === "/forecasting" ? "active" : ""}
            >
              <Link
                className={` flex ${
                  !isOpen ? "flex-col" : "flex-row"
                } sidebar-forecasting-joyride-class`}
                to="/forecasting"
                title="Issue Prediction"
              >
                <Zap className="menu-icon" />
                <div className="sidebar-label">Issue Prediction</div>
              </Link>
            </li>
            <li
              className={location.pathname === "/pii" ? "active" : ""}
            >
              <Link
                className={` flex ${
                  !isOpen ? "flex-col" : "flex-row"
                } sidebar-pii-joyride-class`}
                to="/pii"
                title="PII"
              >
                <Lock className="menu-icon" />
                <div className="sidebar-label">PII</div>
              </Link>
            </li>
            <li
              className={
                location.pathname.includes("/ai-assistance") ? "active" : ""
              }
            >
              <Link
                className={`flex ${!isOpen ? "flex-col" : "flex-row"} sidebar-ai-joyride-class`}
                to="/ai-assistance"
                title="Bluegecko AI Assistance"
              >
                <img
                  src={MyLogo}
                  alt="My Logo"
                  className="menu-icon w-6 h-6" // adjust size as needed
                />
                <div className="sidebar-label">BlueGecko AI</div>
              </Link>
            </li>
            <li
              className={
                location.pathname === "/view-data" ||
                location.pathname.includes("/history-data")
                  ? "active"
                  : ""
              }
            >
              <Link
                className={` flex ${
                  !isOpen ? "flex-col" : "flex-row"
                } sidebar-stt-joyride-class`}
                to="/help"
                title="View Data"
              >
                <FaQuestionCircle className="menu-icon" />
                <div className="sidebar-label">Help</div>
              </Link>
            </li>
          </ul>
        </div>
      )}
    </>
  );
};

export default Sidebar;
